import { render, staticRenderFns } from "./GisButton.vue?vue&type=template&id=639ffdfb&scoped=true&"
import script from "./GisButton.vue?vue&type=script&lang=js&"
export * from "./GisButton.vue?vue&type=script&lang=js&"
import style0 from "./GisButton.vue?vue&type=style&index=0&id=639ffdfb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639ffdfb",
  null
  
)

export default component.exports